import { render, staticRenderFns } from "./NumberSpinner.vue?vue&type=template&id=287659e5&"
import script from "./NumberSpinner.vue?vue&type=script&lang=js&"
export * from "./NumberSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports